module.exports = __webpack_public_path__ + "static/media/pebble-home.d1ca0621.png";